"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoreCard = void 0;
var react_1 = __importStar(require("react"));
var css_1 = require("@emotion/css");
var Card_1 = __importDefault(require("@mui/material/Card"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Divider_1 = __importDefault(require("@mui/material/Divider"));
var Colors = __importStar(require("@brightlayer-ui/colors"));
var prop_types_1 = __importDefault(require("prop-types"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var styles_1 = require("@mui/material/styles");
var ScoreCardClasses_1 = require("./ScoreCardClasses");
var base_1 = require("@mui/base");
var useUtilityClasses = function (ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: ['root'],
        actionItems: ['actionItems'],
        badgeWrapper: ['badgeWrapper'],
        bodyWrapper: ['bodyWrapper'],
        content: ['content'],
        header: ['header'],
        headerBackground: ['headerBackground'],
        headerContent: ['headerContent'],
        headerInfo: ['headerInfo'],
        headerTitle: ['headerTitle'],
        headerSubtitle: ['headerSubtitle'],
    };
    return (0, base_1.unstable_composeClasses)(slots, ScoreCardClasses_1.getScoreCardUtilityClass, classes);
};
var fontColor = function (headerFontColor) { return headerFontColor || Colors.white[50]; };
var Root = (0, styles_1.styled)(Card_1.default, {})(function () { return ({
    flex: '1 1 0px',
}); });
var FlexColumn = (0, styles_1.styled)(Box_1.default, {})(function () { return ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    flex: '1 1 0px',
    overflow: 'hidden',
}); });
var Header = (0, styles_1.styled)(Box_1.default, {
    shouldForwardProp: function (prop) { return !['headerColor', 'headerFontColor'].includes(prop.toString()); },
})(function (_a) {
    var headerColor = _a.headerColor, headerFontColor = _a.headerFontColor, theme = _a.theme;
    return ({
        height: "6.25rem",
        overflow: 'hidden',
        position: 'relative',
        backgroundColor: headerColor || (theme.palette.mode === 'dark' ? theme.palette.primary.dark : theme.palette.primary.main),
        color: fontColor(headerFontColor),
    });
});
var HeaderContent = (0, styles_1.styled)(Box_1.default, {})(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        position: 'relative',
        zIndex: 1,
        alignItems: 'flex-start',
        padding: "1rem ".concat(theme.spacing(2), " 0 ").concat(theme.spacing(2)),
    });
});
var HeaderTitle = (0, styles_1.styled)(Typography_1.default, {
    shouldForwardProp: function (prop) { return prop !== 'headerFontColor'; },
})(function (_a) {
    var headerFontColor = _a.headerFontColor;
    return ({
        color: fontColor(headerFontColor),
        lineHeight: 1.4,
    });
});
var HeaderSubtitle = (0, styles_1.styled)(Typography_1.default, {
    shouldForwardProp: function (prop) { return prop !== 'headerFontColor'; },
})(function (_a) {
    var headerFontColor = _a.headerFontColor;
    return ({
        color: fontColor(headerFontColor),
        lineHeight: 1.4,
    });
});
var HeaderInfo = (0, styles_1.styled)(Typography_1.default, {
    shouldForwardProp: function (prop) { return prop !== 'headerFontColor'; },
})(function (_a) {
    var headerFontColor = _a.headerFontColor;
    return ({
        color: fontColor(headerFontColor),
        fontWeight: 300,
    });
});
var HeaderBackground = (0, styles_1.styled)(Box_1.default, {
    shouldForwardProp: function (prop) { return prop !== 'headerBackgroundImage'; },
})(function (_a) {
    var headerBackgroundImage = _a.headerBackgroundImage;
    return ({
        position: 'absolute',
        zIndex: 0,
        width: '100%',
        backgroundSize: 'cover',
        height: '100%',
        opacity: 0.3,
        backgroundPosition: 'center',
        backgroundImage: "url(".concat(headerBackgroundImage, ")"),
    });
});
var Content = (0, styles_1.styled)(Box_1.default, {})(function () { return ({
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
}); });
var BodyWrapper = (0, styles_1.styled)(Box_1.default, {})(function () { return ({
    flex: '1 1 0px',
}); });
var BadgeWrapper = (0, styles_1.styled)(Box_1.default, {
    shouldForwardProp: function (prop) { return prop !== 'badgeOffset'; },
})(function (_a) {
    var badgeOffset = _a.badgeOffset, theme = _a.theme;
    return ({
        flex: '0 0 auto',
        marginRight: theme.spacing(2),
        marginLeft: theme.spacing(2),
        alignSelf: badgeOffset !== 0 ? 'flex-start' : 'center',
        marginTop: badgeOffset,
    });
});
var ActionItems = (0, styles_1.styled)(Box_1.default, {})(function (_a) {
    var theme = _a.theme;
    return ({
        marginLeft: theme.spacing(1.5),
        cursor: 'pointer',
    });
});
var ScoreCardRender = function (props, ref) {
    var actionLimit = props.actionLimit, actionItems = props.actionItems, actionRow = props.actionRow, badge = props.badge, headerBackgroundImage = props.headerBackgroundImage, children = props.children, classes = props.classes, userClassName = props.className, headerInfo = props.headerInfo, headerTitle = props.headerTitle, headerSubtitle = props.headerSubtitle, headerColor = props.headerColor, headerFontColor = props.headerFontColor, badgeOffset = props.badgeOffset, otherCardProps = __rest(props, ["actionLimit", "actionItems", "actionRow", "badge", "headerBackgroundImage", "children", "classes", "className", "headerInfo", "headerTitle", "headerSubtitle", "headerColor", "headerFontColor", "badgeOffset"]);
    var defaultClasses = useUtilityClasses(props);
    var getBackgroundImage = (0, react_1.useCallback)(function () {
        if (headerBackgroundImage) {
            return (react_1.default.createElement(HeaderBackground, { className: (0, css_1.cx)(defaultClasses.headerBackground, classes.headerBackground), headerBackgroundImage: headerBackgroundImage }));
        }
    }, [headerBackgroundImage, defaultClasses, classes]);
    var getHeaderInfo = (0, react_1.useCallback)(function () {
        if (!headerInfo)
            return;
        if (typeof headerInfo === 'string') {
            return (react_1.default.createElement(HeaderInfo, { noWrap: true, variant: 'body2', headerFontColor: headerFontColor, className: (0, css_1.cx)(defaultClasses.headerInfo, classes.headerInfo) }, headerInfo));
        }
        return headerInfo;
    }, [headerInfo, defaultClasses, classes]);
    var getHeaderSubtitle = (0, react_1.useCallback)(function () {
        if (!headerSubtitle)
            return;
        if (typeof headerSubtitle === 'string') {
            return (react_1.default.createElement(HeaderSubtitle, { headerFontColor: headerFontColor, noWrap: true, variant: 'body2', className: (0, css_1.cx)(defaultClasses.headerSubtitle, classes.headerSubtitle) }, headerSubtitle));
        }
        return headerSubtitle;
    }, [headerSubtitle, defaultClasses, classes]);
    var getHeaderText = (0, react_1.useCallback)(function () { return (react_1.default.createElement(FlexColumn, null,
        react_1.default.createElement(HeaderTitle, { headerFontColor: headerFontColor, variant: 'h6', noWrap: true, className: (0, css_1.cx)(defaultClasses.headerTitle, classes.headerTitle) }, headerTitle),
        getHeaderSubtitle(),
        getHeaderInfo())); }, [defaultClasses, classes, headerTitle, getHeaderSubtitle, getHeaderInfo]);
    var getActionItems = (0, react_1.useCallback)(function () {
        if (actionItems) {
            return actionItems.slice(0, actionLimit).map(function (actionItem, index) { return (react_1.default.createElement(ActionItems, { key: "".concat(index), className: (0, css_1.cx)(defaultClasses.actionItems, classes.actionItems), "data-testid": 'blui-action-item' }, actionItem)); });
        }
    }, [actionItems, actionLimit, defaultClasses, classes]);
    var getHeroes = (0, react_1.useCallback)(function () {
        if (badge) {
            return (react_1.default.createElement(BadgeWrapper, { className: (0, css_1.cx)(defaultClasses.badgeWrapper, classes.badgeWrapper), badgeOffset: badgeOffset, "data-testid": 'blui-badge-wrapper' }, badge));
        }
    }, [badge, defaultClasses, classes]);
    var getFooter = (0, react_1.useCallback)(function () {
        if (actionRow) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Divider_1.default, null),
                actionRow));
        }
    }, [actionRow]);
    return (react_1.default.createElement(Root, __assign({ ref: ref, className: (0, css_1.cx)(defaultClasses.root, classes.root, userClassName), "data-testid": 'blui-score-card-root' }, otherCardProps),
        react_1.default.createElement(Header, { "data-testid": 'blui-score-card-header', className: (0, css_1.cx)(defaultClasses.header, classes.header), headerColor: headerColor, headerFontColor: headerFontColor },
            getBackgroundImage(),
            react_1.default.createElement(HeaderContent, { className: (0, css_1.cx)(defaultClasses.headerContent, classes.headerContent) },
                getHeaderText(),
                getActionItems())),
        react_1.default.createElement(Content, { className: (0, css_1.cx)(defaultClasses.content, classes.content), "data-testid": 'blui-body-content' },
            react_1.default.createElement(BodyWrapper, { className: (0, css_1.cx)(defaultClasses.bodyWrapper, classes.bodyWrapper), "data-testid": 'blui-body-wrapper' }, children),
            getHeroes()),
        getFooter()));
};
/**
 * [ScoreCard](https://brightlayer-ui-components.github.io/react/components/score-card) component
 *
 * Card component that calls attention to particular values.
 */
exports.ScoreCard = react_1.default.forwardRef(ScoreCardRender);
exports.ScoreCard.displayName = 'ScoreCard';
exports.ScoreCard.propTypes = {
    actionItems: prop_types_1.default.arrayOf(prop_types_1.default.element),
    actionLimit: prop_types_1.default.number,
    actionRow: prop_types_1.default.element,
    badge: prop_types_1.default.element,
    badgeOffset: prop_types_1.default.number,
    classes: prop_types_1.default.shape({
        root: prop_types_1.default.string,
        actionItems: prop_types_1.default.string,
        badgeWrapper: prop_types_1.default.string,
        bodyWrapper: prop_types_1.default.string,
        content: prop_types_1.default.string,
        header: prop_types_1.default.string,
        headerBackground: prop_types_1.default.string,
        headerContent: prop_types_1.default.string,
        headerInfo: prop_types_1.default.string,
        headerTitle: prop_types_1.default.string,
        headerSubtitle: prop_types_1.default.string,
    }),
    headerBackgroundImage: prop_types_1.default.string,
    headerColor: prop_types_1.default.string,
    headerFontColor: prop_types_1.default.string,
    headerInfo: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.element]),
    headerTitle: prop_types_1.default.string.isRequired,
    headerSubtitle: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.element]),
};
exports.ScoreCard.defaultProps = {
    actionLimit: 3,
    badgeOffset: 0,
    classes: {},
};
